export const SET_ACTIVE_LINK = "SET_ACTIVE_LINK";
export const SET_LOADING = "SET_LOADING";
export const GET_GAMES = "GET_GAMES";
export const GET_ORIGAMIS = "GET_ORIGAMIS";
export const GET_QUIZES = "GET_QUIZES";
export const GET_RIDDLES = "GET_RIDDLES";
export const GET_FACTS = "GET_FACTS";
export const GET_EXPERIMENTS = "GET_EXPERIMENTS";
export const GET_ENGLISH = "GET_ENGLISH";
